export default {"src":"/_next/static/media/packer_on-light.9c27c6eb.svg","height":72,"width":177,"blurWidth":0,"blurHeight":0};